import { type AnyFunction, type Composed } from './types'

export function compose<T extends Array<AnyFunction>>(...args: T): Composed<T> {
  return args.reduce((previousFn, currentFn) => {
    return (...args) => previousFn(currentFn(...args))
  }) as Composed<T>
}
